import dayjs from '@/utils/dayjs';

function getYesterday() {
    const date = new Date();
    date.setDate(date.getDate() - 1);
    return date;
}

const getYesterdayDayjs = () => dayjs().subtract(1, 'day');

export const getDatesToPick = () => ({
    today: {
        initial: new Date(),
        final: new Date(),
    },
    yesterday: {
        initial: getYesterday(),
        final: getYesterday(),
    },
    lastSevenDays: {
        initial: new Date(getYesterday().getTime() - 6 * 24 * 60 * 60 * 1000),
        final: getYesterday(),
    },
    lastEightDays: {
        initial: new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000),
        final: new Date(),
    },
    lastEightDaysWithoutToday: {
        initial: new Date(new Date().getTime() - 8 * 24 * 60 * 60 * 1000),
        final: getYesterday(),
    },
    thisMonth: {
        initial: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        final: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
    },
    thisMonthHistoric: {
        initial: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        final: getYesterday(),
    },
    lastMonth: {
        initial: new Date(
            new Date().getFullYear(),
            new Date().getMonth() - 1,
            1,
        ),
        final: new Date(new Date().getFullYear(), new Date().getMonth(), 0),
    },
    lastThirdyDaysHistoric: {
        initial: new Date(getYesterday().getTime() - 29 * 24 * 60 * 60 * 1000),
        final: getYesterday(),
    },
    lastThirdyDays: {
        initial: new Date(new Date().getTime() - 29 * 24 * 60 * 60 * 1000),
        final: new Date(),
    },
    lastThreeMonthHistoric: {
        initial: new Date(
            getYesterday().getTime() - 3 * 30 * 24 * 60 * 60 * 1000,
        ),
        final: getYesterday(),
    },
    lastThreeMonth: {
        initial: new Date(new Date().getTime() - 3 * 30 * 24 * 60 * 60 * 1000),
        final: new Date(),
    },
    customDate: {
        initial: null,
        final: null,
    },
});

export const DATES_TO_PICK = getDatesToPick();

export const DATES_TO_PICK_DAYJS = {
    today: {
        initial: dayjs(),
        final: dayjs(),
    },
    yesterday: {
        initial: getYesterdayDayjs(),
        final: getYesterdayDayjs(),
    },
    lastSevenDays: {
        initial: getYesterdayDayjs().subtract(6, 'day'),
        final: getYesterdayDayjs(),
    },
    lastEightDays: {
        initial: dayjs().subtract(7, 'day'),
        final: dayjs(),
    },
    lastEightDaysWithoutToday: {
        initial: dayjs().subtract(8, 'day'),
        final: getYesterdayDayjs(),
    },
    thisMonth: {
        initial: dayjs().startOf('month'),
        final: dayjs().endOf('month'),
    },
    thisMonthHistoric: {
        initial: dayjs().startOf('month'),
        final: getYesterdayDayjs(),
    },
    lastSixMonth: {
        initial: dayjs().subtract(6, 'month'),
        final: dayjs(),
    },
    lastThirdyDays: {
        initial: dayjs().subtract(29, 'day'),
        final: dayjs(),
    },
    lastMonth: {
        initial: dayjs().subtract(1, 'month').startOf('month'),
        final: dayjs().subtract(1, 'month').endOf('month'),
    },
    lastThreeMonthsHistoric: {
        initial: getYesterdayDayjs().subtract(3, 'month'),
        final: getYesterdayDayjs(),
    },
    lastThirdyDaysHistoric: {
        initial: dayjs().subtract(1, 'day').subtract(29, 'day').toDate(),
        final: dayjs().subtract(1, 'day').toDate(),
    },
    lastThreeMonthHistoric: {
        initial: dayjs().subtract(1, 'day').subtract(90, 'day').toDate(),
        final: dayjs().subtract(1, 'day').toDate(),
    },
    lastThreeMonth: {
        initial: dayjs().subtract(3 * 30, 'day'),
        final: dayjs(),
    },
    customDate: {
        initial: null,
        final: null,
    },
};

export const DATE_TO_PICK_EXTENDS = {
    today: {
        initial: new Date(),
        final: new Date(),
    },
    lastEightDays: {
        initial: new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000),
        final: new Date(),
    },
    thisMonth: {
        initial: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        final: new Date(),
    },
    lastMonth: {
        initial: new Date(
            new Date().getFullYear(),
            new Date().getMonth() - 1,
            1,
        ),
        final: new Date(new Date().getFullYear(), new Date().getMonth(), 0),
    },
    lastThirdyDays: {
        initial: new Date(new Date().getTime() - 29 * 24 * 60 * 60 * 1000),
        final: new Date(),
    },
    lastThreeMonth: {
        initial: new Date(new Date().getTime() - 3 * 30 * 24 * 60 * 60 * 1000),
        final: new Date(),
    },
    lastSixMonth: {
        initial: new Date(
            new Date().getFullYear(),
            new Date().getMonth() - 6,
            new Date().getDate(),
        ),
        final: new Date(),
    },
    customDate: {
        initial: null,
        final: null,
    },
};

export const DATE_TO_PICK_EXTENDS_DAYJS = {
    today: {
        initial: dayjs(),
        final: dayjs(),
    },
    lastEightDays: {
        initial: dayjs().subtract(7, 'day'),
        final: dayjs(),
    },
    thisMonth: {
        initial: dayjs().startOf('month'),
        final: dayjs(),
    },
    lastMonth: {
        initial: dayjs().subtract(1, 'month').startOf('month'),
        final: dayjs().subtract(1, 'month').endOf('month'),
    },
    lastThirdyDays: {
        initial: dayjs().subtract(29, 'day'),
        final: dayjs(),
    },
    lastThreeMonth: {
        initial: dayjs().subtract(3, 'month'),
        final: dayjs(),
    },
    lastSixMonth: {
        initial: dayjs().subtract(6, 'month'),
        final: dayjs(),
    },
    customDate: {
        initial: null,
        final: null,
    },
};

export const DATE_TO_PICK_TOTEM_LOGS = {
    today: {
        initial: new Date(),
        final: new Date(),
    },
    lastTwoDays: {
        initial: new Date(new Date().getTime() - 1 * 24 * 60 * 60 * 1000),
        final: new Date(),
    },
    lastSevenDays: {
        initial: new Date(new Date().getTime() - 6 * 24 * 60 * 60 * 1000),
        final: new Date(),
    },
    lastFifTeenDays: {
        initial: new Date(new Date().getTime() - 14 * 24 * 60 * 60 * 1000),
        final: new Date(),
    },
    lastThirdyDays: {
        initial: new Date(new Date().getTime() - 29 * 24 * 60 * 60 * 1000),
        final: new Date(),
    },
};

export enum ExcelFormat {
    money = '[$R$-416] #,##0.00;[RED]-[$R$-416] #,##0.00',
    dateTime = 'dd/mm/yyyy HH:mm:ss',
}

export const WHATSAPP_SUPORT = 'https://wa.me/558521807303';

export const defaultUrlProductImage =
    'https://storage.googleapis.com/api-prd-storage/product/000d4e10-059e-4994-b281-ae73541f6625.jpeg';

export const TaxSituations: Record<string, string> = {
    '': '',
    '01': 'Operação tributável: base de cálculo = valor da operação (alíquota normal - cumulativo/não cumulativo)',
    '02': 'Operação tributável: base de cálculo = valor da operação (alíquota diferenciada)',
    '03': 'Operação tributável: base de cálculo = quantidade vendida x alíquota por unidade de produto',
    '04': 'Operação tributável: tributação monofásica (alíquota zero)',
    '05': 'Operação tributável: substituição tributária',
    '06': 'Operação tributável: alíquota zero',
    '07': 'Operação isenta da contribuição',
    '08': 'Operação sem incidência da contribuição',
    '09': 'Operação com suspensão da contribuição',
    '49': 'Outras operações de saída',
    '50': 'Operação com direito a crédito: vinculada exclusivamente a receita tributada no mercado interno',
    '51': 'Operação com direito a crédito: vinculada exclusivamente a receita não tributada no mercado interno',
    '52': 'Operação com direito a crédito: vinculada exclusivamente a receita de exportação',
    '53': 'Operação com direito a crédito: vinculada a receitas tributadas e não-tributadas no mercado interno',
    '54': 'Operação com direito a crédito: vinculada a receitas tributadas no mercado interno e de exportação',
    '55': 'Operação com direito a crédito: vinculada a receitas não-tributadas no mercado interno e de exportação',
    '56': 'Operação com direito a crédito: vinculada a receitas tributadas e não-tributadas no mercado interno e de exportação',
    '60': 'Crédito presumido: operação de aquisição vinculada exclusivamente a receita tributada no mercado interno',
    '61': 'Crédito presumido: operação de aquisição vinculada exclusivamente a receita não-tributada no mercado interno',
    '62': 'Crédito presumido: operação de aquisição vinculada exclusivamente a receita de exportação',
    '63': 'Crédito presumido: operação de aquisição vinculada a receitas tributadas e não-tributadas no mercado interno',
    '64': 'Crédito presumido: operação de aquisição vinculada a receitas tributadas no mercado interno e de exportação',
    '65': 'Crédito presumido: operação de aquisição vinculada a receitas não-tributadas no mercado interno e de exportação',
    '66': 'Crédito presumido: operação de aquisição vinculada a receitas tributadas e não-tributadas no mercado interno e de exportação',
    '67': 'Crédito presumido: outras operações',
    '70': 'Operação de aquisição sem direito a crédito',
    '71': 'Operação de aquisição com isenção',
    '72': 'Operação de aquisição com suspensão',
    '73': 'Operação de aquisição a alíquota zero',
    '74': 'Operação de aquisição sem incidência da contribuição',
    '75': 'Operação de aquisição por substituição tributária',
    '98': 'Outras operações de entrada',
    '99': 'Outras operações',
} as const;

export type TaxSituationKey = keyof typeof TaxSituations;
